import React from 'react';
import styled from '@emotion/styled';
import { DropdownItemHint } from './DropdownItemHint';
import { ITheme } from '../../../themer';
import { Color } from '../../../../styles/Color';
import { Css } from '../../../utils';

export const StyledDropdownItem = styled.div<{}, ITheme>`
	display: flex;
	justify-content: space-between;
	position: relative;
	line-height: ${({ theme: { input } }) => input.lineHeight};

	color: ${Color.OnBackground};
	font-size: ${Css.pxToRem(16)};
	font-weight: 500;
	text-align: left;
`;

interface IDropdownItemProps {
	displayValue: string | React.JSX.Element;
	hint?: string;
}

export function DropdownItem({ displayValue, hint }: IDropdownItemProps) {
	return (
		<StyledDropdownItem>
			{typeof displayValue === 'string' ? (
				<div>{displayValue}</div>
			) : (
				displayValue
			)}
			{hint && <DropdownItemHint>{hint}</DropdownItemHint>}
		</StyledDropdownItem>
	);
}
